import React from "react";
import { Services } from '../components/Services';

const ServicesPage = () => (
  <div className="pt-8">
    <Services />
  </div>
);

export default ServicesPage;